Hideaways.header = function() {
    var header = new Header();
    header.init();

    Hideaways._header = header;
}
